{
  "enums": {
    "claimStatus": {
      "draft": "Draf",
      "submitted": "Diajukan",
      "accepted": "Diterima",
      "denied": "Ditolak",
      "paid": "Dibayar"
    },
    "chargeStatus": {
      "pending": "Menunggu",
      "unbilled": "Belum ditagih",
      "posted": "Diposting",
      "billed": "Ditagih",
      "adjusted": "Disesuaikan",
      "voided": "Dibatalkan"
    },
    "statementDelivery": {
      "print": "Cetak",
      "email": "Email",
      "both": "Cetak & Email",
      "mail": "Pos"
    },
    "statementStatus": {
      "generated": "Dibuat",
      "sent": "Dikirim",
      "viewed": "Dilihat"
    },
    "denialStatus": {
      "new": "Baru",
      "inReview": "Sedang Ditinjau",
      "appealing": "Mengajukan Banding",
      "resolved": "Diselesaikan",
      "writtenOff": "Dihapusbukukan"
    },
    "denialPriority": {
      "low": "Rendah",
      "medium": "Sedang",
      "high": "Tinggi"
    },
    "claimType": {
      "professional": "Profesional",
      "institutional": "Institusi",
      "dental": "Gigi",
      "pharmacy": "Farmasi"
    },
    "paymentMethod": {
      "cash": "Tunai",
      "check": "Cek",
      "creditCard": "Kartu Kredit",
      "debitCard": "Kartu Debit",
      "bankTransfer": "Transfer Bank",
      "digitalWallet": "Dompet Digital",
      "insurance": "Asuransi"
    },
    "paymentSource": {
      "patient": "Pasien",
      "insurance": "Asuransi",
      "thirdParty": "Pihak Ketiga"
    }
  },
  "form": {
    "validation": {
      "patientIdRequired": "ID pasien wajib diisi",
      "encounterIdRequired": "ID kunjungan wajib diisi",
      "payerIdRequired": "ID pembayar wajib diisi",
      "chargeCodeRequired": "Kode tagihan wajib diisi",
      "unitPriceRequired": "Harga satuan wajib diisi",
      "amountRequired": "Jumlah wajib diisi",
      "amountPositive": "Jumlah harus lebih besar dari nol",
      "chargeSelectionRequired": "Pilih setidaknya satu tagihan"
    }
  },
  "pages": {
    "statements": {
      "title": "Laporan Tagihan",
      "labels": {
        "dashboard": "Dasbor",
        "patient": "Pasien",
        "from": "Dari",
        "to": "Sampai",
        "batchGenerate": "Buat Massal",
        "previewStatement": "Pratinjau Laporan",
        "generatePrint": "Buat & Cetak",
        "generateEmail": "Buat & Email",
        "printEmail": "Cetak & Email",
        "print": "Cetak",
        "email": "Email"
      },
      "placeholders": {
        "searchPatient": "Cari berdasarkan nama atau MRN..."
      },
      "aria": {
        "periodFrom": "Periode laporan dari",
        "periodTo": "Periode laporan sampai"
      },
      "table": {
        "header": {
          "statementHistory": "Riwayat Laporan",
          "patient": "Pasien",
          "mrn": "MRN",
          "date": "Tanggal",
          "amount": "Jumlah",
          "delivery": "Pengiriman",
          "status": "Status"
        },
        "preview": {
          "modal": "Pratinjau Laporan",
          "patientStatement": "Laporan Pasien",
          "patient": "Pasien:",
          "mrn": "MRN:",
          "statementDate": "Tanggal Laporan:",
          "period": "Periode:",
          "lineItemHeader": {
            "date": "Tanggal",
            "description": "Deskripsi",
            "charges": "Biaya",
            "payments": "Pembayaran",
            "balance": "Saldo"
          },
          "openingBalance": "Saldo Awal",
          "totals": "Total",
          "amountDue": "Jumlah Terutang"
        }
      },
      "states": {
        "generating": "Membuat...",
        "loading": "Membuat pratinjau...",
        "noPatients": "Tidak ada pasien ditemukan",
        "noStatementData": "Tidak ada data laporan tersedia",
        "loadingHistory": "Memuat riwayat...",
        "noStatementsGenerated": "Belum ada laporan dibuat",
        "selectedPatientId": "ID pasien terpilih: {{id}}"
      },
      "toast": {
        "generated": "Laporan dibuat",
        "generatedError": "Gagal membuat laporan",
        "batchStarted": "Pembuatan massal dimulai: {{count}} laporan dalam antrean",
        "batchError": "Gagal memulai pembuatan massal"
      }
    },
    "claims": {
      "title": "Manajemen Klaim",
      "labels": {
        "dashboard": "Dasbor",
        "createClaim": "Buat Klaim",
        "filters": "Filter",
        "submit": "Kirim",
        "appeal": "Banding",
        "denialReason": "Alasan Penolakan",
        "expandHint": "Perluas klaim untuk melihat item baris di halaman klaim khusus.",
        "cancel": "Batal"
      },
      "filter": {
        "allStatuses": "Semua Status"
      },
      "placeholders": {
        "filterPayer": "Filter berdasarkan pembayar..."
      },
      "aria": {
        "claimDateFrom": "Tanggal klaim dari",
        "claimDateTo": "Tanggal klaim sampai"
      },
      "table": {
        "header": {
          "claimNumber": "Klaim #",
          "patient": "Pasien",
          "payer": "Pembayar",
          "total": "Total",
          "status": "Status",
          "submitted": "Dikirim",
          "actions": "Tindakan"
        }
      },
      "modal": {
        "createClaim": "Buat Klaim dari Biaya",
        "patientId": "ID Pasien *",
        "payerId": "ID Pembayar *",
        "selectCharges": "Pilih Biaya ({{selected}} dipilih)",
        "noBilledCharges": "Tidak ada biaya yang belum ditagih untuk pasien ini"
      },
      "states": {
        "loading": "Memuat klaim...",
        "noClaims": "Tidak ada klaim ditemukan",
        "creating": "Membuat..."
      },
      "toast": {
        "created": "Klaim dibuat",
        "createdError": "Gagal membuat klaim",
        "submitted": "Klaim dikirim",
        "submittedError": "Gagal mengirim klaim",
        "resubmitted": "Klaim dikirim ulang untuk banding",
        "resubmittedError": "Gagal mengirim ulang klaim",
        "patientPayerRequired": "Pasien dan pembayar wajib diisi",
        "chargeRequired": "Pilih setidaknya satu biaya"
      }
    },
    "charges": {
      "title": "Manajemen Tagihan",
      "labels": {
        "dashboard": "Dasbor",
        "newCharge": "Tagihan Baru",
        "totalChargesPeriod": "Total Tagihan (Periode)",
        "filters": "Filter",
        "cancel": "Batal"
      },
      "filter": {
        "allStatuses": "Semua Status"
      },
      "placeholders": {
        "filterPatient": "Filter berdasarkan pasien..."
      },
      "aria": {
        "serviceDateFrom": "Tanggal layanan dari",
        "serviceDateTo": "Tanggal layanan sampai"
      },
      "table": {
        "header": {
          "date": "Tanggal",
          "patient": "Pasien",
          "encounter": "Kunjungan",
          "code": "Kode",
          "description": "Deskripsi",
          "qty": "Jml",
          "unitPrice": "Harga Satuan",
          "total": "Total",
          "status": "Status",
          "actions": "Tindakan"
        }
      },
      "actions": {
        "void": "Batalkan"
      },
      "modal": {
        "voidCharge": "Batalkan Tagihan",
        "voidChargeConfirm": "Batalkan tagihan {{code}} - {{description}} ({{amount}})?",
        "reason": "Alasan *",
        "reasonPlaceholder": "Masukkan alasan pembatalan..."
      },
      "states": {
        "loading": "Memuat tagihan...",
        "noCharges": "Tidak ada tagihan ditemukan untuk periode ini",
        "voiding": "Membatalkan..."
      },
      "toast": {
        "voided": "Tagihan dibatalkan",
        "voidedError": "Gagal membatalkan tagihan",
        "reasonRequired": "Alasan wajib diisi"
      }
    },
    "payments": {
      "title": "Posting Pembayaran",
      "labels": {
        "dashboard": "Dasbor",
        "uploadEraEob": "Unggah ERA/EOB",
        "postPayment": "Posting Pembayaran",
        "totalPaymentsPeriod": "Total Pembayaran (Periode)",
        "filters": "Filter",
        "cancel": "Batal"
      },
      "placeholders": {
        "filterPatient": "Filter berdasarkan pasien..."
      },
      "aria": {
        "paymentDateFrom": "Tanggal pembayaran dari",
        "paymentDateTo": "Tanggal pembayaran sampai"
      },
      "table": {
        "header": {
          "date": "Tanggal",
          "patient": "Pasien",
          "claimNumber": "Klaim #",
          "amount": "Jumlah",
          "method": "Metode",
          "reference": "Referensi",
          "postedBy": "Diposting Oleh"
        }
      },
      "modal": {
        "postPayment": "Posting Pembayaran",
        "patientId": "ID Pasien *",
        "claimId": "ID Klaim (opsional)",
        "claimIdHint": "Kosongkan untuk pembayaran yang tidak diterapkan",
        "amount": "Jumlah *",
        "method": "Metode *",
        "referenceNumber": "Nomor Referensi",
        "referenceHint": "Nomor cek, ID transaksi, dll.",
        "notes": "Catatan"
      },
      "states": {
        "loading": "Memuat pembayaran...",
        "noPayments": "Tidak ada pembayaran untuk periode ini",
        "posting": "Memposting..."
      },
      "toast": {
        "posted": "Pembayaran berhasil diposting",
        "postedError": "Gagal memposting pembayaran",
        "patientAmountRequired": "Pasien dan jumlah wajib diisi",
        "validAmount": "Masukkan jumlah yang valid",
        "eraEobSoon": "Unggah ERA/EOB segera hadir"
      }
    },
    "chargeForm": {
      "title": "Buat Tagihan",
      "labels": {
        "patientId": "ID Pasien *",
        "encounterId": "ID Kunjungan *",
        "chargeCode": "Kode Tagihan *",
        "description": "Deskripsi",
        "cptCode": "Kode CPT",
        "quantity": "Jumlah *",
        "unitPrice": "Harga Satuan *"
      },
      "placeholders": {
        "chargeCode": "Cari master tagihan...",
        "cptCode": "Cari kode prosedur CPT..."
      },
      "buttons": {
        "cancel": "Batal",
        "create": "Buat Tagihan"
      },
      "toast": {
        "created": "Tagihan dibuat",
        "createdError": "Gagal membuat tagihan"
      }
    },
    "claimForm": {
      "title": "Buat Klaim",
      "labels": {
        "patientId": "ID Pasien *",
        "encounterId": "ID Kunjungan *",
        "payerId": "ID Pembayar *",
        "claimType": "Jenis Klaim *",
        "diagnosisCodes": "Kode Diagnosis",
        "selectCharges": "Pilih Biaya ({{selected}} dipilih)",
        "notes": "Catatan"
      },
      "placeholders": {
        "diagnosisCodes": "Kode ICD-10 dipisah koma (mis. J06.9, R05)"
      },
      "buttons": {
        "cancel": "Batal",
        "create": "Buat Klaim"
      },
      "toast": {
        "created": "Klaim dibuat",
        "createdError": "Gagal membuat klaim"
      }
    },
    "paymentForm": {
      "title": "Posting Pembayaran",
      "labels": {
        "patientId": "ID Pasien *",
        "claimId": "ID Klaim",
        "amount": "Jumlah *",
        "method": "Metode Pembayaran *",
        "source": "Sumber",
        "referenceNumber": "Nomor Referensi",
        "notes": "Catatan"
      },
      "placeholders": {
        "claimId": "Opsional — tautkan ke klaim",
        "reference": "Referensi transaksi atau cek"
      },
      "buttons": {
        "cancel": "Batal",
        "post": "Posting Pembayaran"
      },
      "toast": {
        "recorded": "Pembayaran tercatat",
        "recordedError": "Gagal mencatat pembayaran"
      }
    },
    "denials": {
      "title": "Manajemen Penolakan",
      "subtitle": "Lacak dan kelola penolakan klaim penagihan",
      "placeholders": {
        "search": "Cari klaim..."
      },
      "filter": {
        "all": "Semua"
      },
      "checkbox": {
        "assignedToMe": "Ditugaskan kepada saya"
      },
      "table": {
        "header": {
          "claimNumber": "No. Klaim",
          "patient": "Pasien",
          "denialCode": "Kode Penolakan",
          "denialReason": "Alasan Penolakan",
          "amount": "Jumlah",
          "daysRemaining": "Sisa Hari",
          "status": "Status",
          "assignedTo": "Ditugaskan Ke",
          "actions": "Tindakan"
        }
      },
      "actions": {
        "review": "Tinjau",
        "appeal": "Banding",
        "writeOff": "Hapus Buku",
        "cancel": "Batal"
      },
      "modal": {
        "appealReason": "Alasan Banding",
        "appealPlaceholder": "Jelaskan alasan banding...",
        "submitAppeal": "Kirim Banding",
        "writeOffTitle": "Hapus Buku Penolakan",
        "writeOffConfirm": "Apakah Anda yakin ingin menghapus buku klaim {{claimNumber}} sebesar {{amount}}? Tindakan ini tidak dapat dibatalkan.",
        "writeOffButton": "Hapus Buku"
      },
      "states": {
        "loading": "Memuat penolakan...",
        "noDenials": "Tidak ada penolakan ditemukan",
        "submitting": "Mengirim..."
      },
      "toast": {
        "updateError": "Gagal memperbarui status penolakan",
        "movedToReview": "Klaim {{claimNumber}} dipindahkan ke tinjauan",
        "appealSubmitted": "Banding dikirim",
        "writtenOff": "Klaim {{claimNumber}} dihapus buku"
      }
    }
  },
  "__review_denialReason": "Backend payer-authored — Phase 9, do not translate",
  "__review_denialCode": "Backend payer-authored — Phase 9, do not translate",
  "__review_chargeDescription": "Backend payer-authored — Phase 9, do not translate",
  "__review_chargeCode": "Backend payer-authored — Phase 9, do not translate"
}
